import React from 'react';
import styled from 'styled-components';
import { Flex } from 'src/packages/core';

export const AccordionSection = styled((props) => <Flex {...props} />)`
  flex-direction: column;
  width: 100%;
  ${({ styles }) => styles}
`;

export const AccordionItemWrap = styled((props) => <Flex {...props} />)`
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid ${({ defaulttheme }) => defaulttheme.colors.border.lighter};
  gap: 24px;
  padding: 24px 0;
  ${({ styles }) => styles}
`;

export const AccordionTitleWrap = styled((props) => <Flex {...props} />)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer !important;
  gap: 8px;

  svg {
    cursor: pointer !important;

    * {
      cursor: pointer !important;
    }
  }
`;

export const Dropdown = styled((props) => <Flex {...props} />)`
  width: 95%;
  flex-direction: column;
  cursor: inherit;
  margin-right: auto;
`;

export const Highlight = styled((props) => <Flex {...props} />)`
  width: 95%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block !important;
  & :first-child {
    display: inline !important;
  }
  * {
    font-size: inherit;
    font-weight: inherit;
    display: inline-block;
  }
`;

export const AccordionTitle = styled((props) => <Flex {...props} />)`
  align-items: center;
  width: 100%;
`;
